export default "__VITE_ASSET__f5$AGZzf__"